<template>
  <div class=" padding-left-30 padding-right-30 padding-bottom-30">

    <div class="vctb-list">
      <div class="vctb-item" :class="{'vctb-item-active':vctbIndex==0}" @click="clickvctb(0)">
        专利 ({{ com[1].totalnum }})
      </div>
      <div class="vctb-item" :class="{'vctb-item-active':vctbIndex==1}" @click="clickvctb(1)">
        商标 ({{ com[0].totalnum }})
      </div>
      <div class="vctb-item" :class="{'vctb-item-active':vctbIndex==2}" @click="clickvctb(2)">
        软著 ({{ com[2].totalnum }})
      </div>
      <div class="vctb-item" :class="{'vctb-item-active':vctbIndex==3}" @click="clickvctb(3)">
        作品 ({{ com[3].totalnum }})
      </div>
    </div>
    <template v-if="vctbIndex==0">
      <div>
        <div class="box5 box2_cc">
          <!-- <div class="box5_text1 text-cut text-center" style="font-weight: 600;">
            序号
          </div> -->
          <div class="box5_text2 text-bold">专利名称</div>
          <div class="box5_text2 text-bold">申请日</div>
          <div class="box5_text2 text-bold">申请号</div>
          <div class="box5_text2 text-bold">公开（公布）号
          </div>
          <div class="box5_text2 text-bold">最新法律状态</div>
          <div class="box5_text2 text-bold">专利类型</div>
          <div class="box5_text2 width-50 text-bold" style="flex:none;">操作</div>
          <!-- 	<div class="box5_text2 text-cut" style="font-weight: 600;">专利状态</div>
          <div class="box5_text2 text-center" style="font-weight: 600;">公开（公布）日
          </div> -->
        </div>
        <div v-for="(item, index) in patent_list" :key="index" class="box5">
          <!-- <div class="box5_text1 text-center">
            <div class="response text-center">{{ index+1 }}</div>
          </div> -->
          <div class="box5_text2  cpoint" @click="toout(item.href)">
            <!-- style="color: #0070c0;" -->
            {{ item.name ? item.name : "--" }}
          </div>
          <div class="box5_text2 ">{{ item.date || '--' }}</div>
          <div class="box5_text2 ">{{ item.number || '--' }}</div>
          <div class="box5_text2 ">{{ item.public_number || '--' }}</div>
          <div class="box5_text2 ">{{ item.status || '--' }}</div>
          <div class="box5_text2 ">{{ item.cat || '--' }}</div>
          <!-- <div class="box5_text2 text-center">{{ item.status }}</div>
          <div class="box5_text2 text-center">{{ item.date_end }}</div> -->
          <div class="box5_text2 width-50" style="flex:none;">
            <span class="cpoint" style="color: #0070c0;" @click="showDialog(1,item)">详情</span>
          </div>
        </div>
        <div class="padding-bottom-40" v-if="!patent_list.length">
          <nomore></nomore>
        </div>

        <div class="text-right" style="padding: 20px 0;">
          <el-pagination background :page-size="com[1].pagesize" :page-sizes="pageSizes"
              :hide-on-single-page="false" layout="prev, pager, next,sizes"
              @size-change="handleSizeChange($event,1)" @current-change="handleCurrentChange($event,1)"
              :current-page="com[1].currentPage" :total="com[1].totalnum">
          </el-pagination>
        </div>
      </div>
    </template>
    <template v-else-if="vctbIndex==1">
      <div>
        <div class="box5 box2_cc">
          <div class="box5_text1 text-cut text-center" style="font-weight: 600;">
            序号
          </div>
          <div class="box5_text2 text-center" style="font-weight: 600;width: 15%;">
            申请日期
          </div>
          <div class="box5_text2 text-cut" style="font-weight: 600;width: 15%;">商标
          </div>
          <div class="box5_text2 text-cut" style="font-weight: 600;width: 30%;">
            商标名称
          </div>
          <div class="box5_text2 text-cut" style="font-weight: 600;width: 15%;">
            注册号
          </div>
          <div class="box5_text2 text-center" style="font-weight: 600;width: 15%;">
            国际分类
          </div>
          <div class="box5_text2 text-cut" style="font-weight: 600;width: 15%;">
            商标状态
          </div>
          <div class="box5_text2 width-100 text-bold" style="flex:none;">操作</div>
          <!-- <div class="box5_text2 text-cut" style="font-weight: 600;width: 15%;">注册公告日期</div> -->
        </div>
        <div v-for="(item, index) in brand_list" :key="index" class="box5">
          <div class="box5_text1 text-center">
            <div class="response text-center">{{ index + 1 }}</div>
          </div>
          <div class="box5_text2 text-center" style="width: 15%;">{{ item.date || '--' }}
          </div>
          <div class="box5_text2 text-center" style="width: 15%;">
            <img style="width: 50px;height: auto;" :src="item.pic | addurl" alt="" srcset="">
          </div>
          <div class="box5_text2 text-center cpoint" @click="toout(item.href)"
              style="color: #0070c0;width: 30%;">
            {{ item.name || '--' }}
          </div>
          <div class="box5_text2 text-center" style="width: 15%;">
            {{ item.register_num || '--' }}
          </div>
          <div class="box5_text2 text-center" style="width: 15%;">{{ item.cat || '--' }}
          </div>
          <div class="box5_text2 text-center" style="width: 15%;">
            <!-- <span v-if="item.status == 0">审核中</span>
          <span v-if="item.status == 1">商标已注册</span>
          <span v-if="item.status == 2">驳回复审中</span> -->
            {{ item.status || '--' }}
          </div>
          <div class="box5_text2 width-100" style="flex:none;">
            <span class="cpoint" style="color: #0070c0;" @click="showDialog(0,item)">详情</span>
          </div>
          <!-- <div class="box5_text2 text-center" style="width: 15%;">{{ item.register_date }}</div> -->
        </div>
        <div class="padding-bottom-40" v-if="!brand_list.length">
          <nomore></nomore>
        </div>

        <div class="text-right" style="padding: 20px 0">
          <el-pagination background :page-size="com[0].pagesize" :page-sizes="pageSizes"
              :hide-on-single-page="false" layout="prev, pager, next,sizes"
              @size-change="handleSizeChange($event,0)" @current-change="handleCurrentChange($event,0)"
              :current-page="com[0].currentPage" :total="com[0].totalnum">
          </el-pagination>
        </div>
      </div>
    </template>

    <template v-else-if="vctbIndex==2">
      <div class="flex justify-between align-center toptitle">
        <div class="topleft">软件著作权<span class="rinum"></span></div>
      </div>
      <div>
        <div class="box5 box2_cc">
          <div class="box5_text1 text-cut text-center" style="font-weight: 600;">
            序号
          </div>
          <div class="box5_text2 text-cut" style="font-weight: 600;">登记批准日期</div>
          <div class="box5_text2 text-cut" style="font-weight: 600;">软件全称</div>
          <div class="box5_text2 text-cut" style="font-weight: 600;">软件简称</div>
          <div class="box5_text2 text-cut" style="font-weight: 600;">登记号</div>
          <div class="box5_text2 text-cut" style="font-weight: 600;">分类号</div>
          <div class="box5_text2 text-center" style="font-weight: 600;">版本号</div>
          <div class="box5_text2 text-center" style="font-weight: 600;">首次发表日期
          </div>
        </div>
        <div v-for="(item, index) in softright_list" :key="index" class="box5">
          <div class="box5_text1 text-center">
            <div class="response text-center">{{ index + 1 }}</div>
          </div>
          <div class="box5_text2 text-center">{{ item.complete_date }}</div>
          <div class="box5_text2 text-center cpoint" style="color: #0070c0;">
            {{ item.name ? item.name : "--" }}
          </div>
          <div class="box5_text2 text-center">
            {{ item.introduce || '--' }}
          </div>
          <div class="box5_text2 text-center">
            {{ item.register_num || '--' }}
          </div>
          <div class="box5_text2 text-center">{{ item.cat || '--' }}</div>
          <div class="box5_text2 text-center">{{ item.version || '--' }}</div>
          <div class="box5_text2 text-center">{{ item.fabiao_date || '--' }}</div>
        </div>
        <div class="padding-bottom-40" v-if="!softright_list.length">
          <nomore></nomore>
        </div>

        <div class="text-right" style="padding: 20px 0">
          <el-pagination background :page-size="com[2].pagesize" :page-sizes="pageSizes"
              :hide-on-single-page="false" layout="prev, pager, next,sizes"
              @size-change="handleSizeChange($event,0)" @current-change="handleCurrentChange($event,2)"
              :current-page="com[2].currentPage" :total="com[2].totalnum">
          </el-pagination>
        </div>
      </div>
    </template>

    <template v-else-if="vctbIndex==3">
      <div class="flex justify-between align-center toptitle">
        <div class="topleft">作品著作权<span class="rinum"></span></div>
      </div>
      <div>
        <div class="box5 box2_cc">
          <div class="box5_text1 text-cut text-center" style="font-weight: 600;">
            序号
          </div>
          <div class="box5_text2 text-cut" style="font-weight: 600;width: 22.5%;">
            作品名称
          </div>
          <div class="box5_text2 text-cut" style="font-weight: 600;width: 22.5%;">
            登记号
          </div>
          <div class="box5_text2 text-cut" style="font-weight: 600;width: 22.5%;">
            作品类别
          </div>
          <div class="box5_text2 text-cut" style="font-weight: 600;width: 22.5%;">
            创作完成日期
          </div>
          <div class="box5_text2 text-cut" style="font-weight: 600;width: 22.5%;">
            登记日期
          </div>
          <div class="box5_text2 text-cut" style="font-weight: 600;width: 22.5%;">
            首次发表日期
          </div>
        </div>
        <div v-for="(item, index) in copyright_list" :key="index" class="box5">
          <div class="box5_text1 text-center">
            <div class="response text-center">{{ index + 1 }}</div>
          </div>
          <div class="box5_text2 text-center cpoint" @click="toout(item.href)"
              style="color: #0070c0;width: 22.5%;">
            {{ item.name ? item.name : "--" }}
          </div>
          <div class="box5_text2 text-center" style="width: 22.5%;">
            {{ item.register_num || '--' }}
          </div>
          <div class="box5_text2 text-center" style="width: 22.5%;">
            {{ item.cat || '--' }}
          </div>
          <div class="box5_text2 text-center" style="width: 22.5%;">
            {{ item.complete_date || '--' }}
          </div>
          <div class="box5_text2 text-center" style="width: 22.5%;">
            {{ item.date || '--' }}
          </div>
          <div class="box5_text2 text-center" style="width: 22.5%;">
            {{ item.fabiao_date || '--' }}
          </div>
        </div>
        <div class="padding-bottom-40" v-if="!copyright_list.length">
          <nomore></nomore>
        </div>

        <div class="text-right" style="padding: 20px 0">
          <el-pagination background :page-size="com[3].pagesize" :page-sizes="pageSizes"
              :hide-on-single-page="false" layout="prev, pager, next,sizes"
              @size-change="handleSizeChange($event,0)" @current-change="handleCurrentChange($event,3)"
              :current-page="com[3].currentPage" :total="com[3].totalnum">
          </el-pagination>
        </div>
      </div>
    </template>


    <el-dialog title="商标信息详情" :visible.sync="dialogData[0].show">
      <div style="" v-if="dialogData[0].showData">
        <table class="pure-table pure-table-bordered">
          <tbody>
          <tr>
            <td style=" background: #F7F7F7;">商标名称</td>
            <td>{{ dialogData[0].showData.name || "--" }}</td>
          </tr>
          <tr>
            <td style="background: #F7F7F7;">注册号</td>
            <td>{{ dialogData[0].showData.register_num || "--" }}</td>
          </tr>
          <tr>
            <td style="background: #F7F7F7;">商标状态</td>
            <td>{{ dialogData[0].showData.status || "--" }}</td>
          </tr>
          <tr>
            <td style="background: #F7F7F7;">国际分类号</td>
            <td>{{ dialogData[0].showData.cat || "--" }}</td>
          </tr>
          <tr>
            <td style="background: #F7F7F7;">申请时间</td>
            <td>{{ dialogData[0].showData.date || "--" }}</td>
          </tr>
          <tr>
            <td style="background: #F7F7F7;">专用权期限</td>
            <td>{{ dialogData[0].showData.brandExpiredStart || "--" }}</td>
          </tr>
          <tr>
            <td style="background: #F7F7F7;">商标代理机构</td>
            <td>{{ dialogData[0].showData.agency || "--" }}</td>
          </tr>
          <tr>
            <td style="background: #F7F7F7;">初审公告号</td>
            <td>{{ dialogData[0].showData.firstAuditNum || "--" }}</td>
          </tr>
          <tr>
            <td style="background: #F7F7F7;">初审公告日期</td>
            <td>{{ dialogData[0].showData.firstAuditDate || "--" }}</td>
          </tr>
          <tr>
            <td style="background: #F7F7F7;">注册公告号</td>
            <td>{{ dialogData[0].showData.annNum || "--" }}</td>
          </tr>
          <tr>
            <td style="background: #F7F7F7;">申请人</td>
            <td>{{ dialogData[0].showData.regName || "--" }}</td>
          </tr>
          <tr>
            <td style="background: #F7F7F7;">申请地址</td>
            <td>{{ dialogData[0].showData.regAddress || "--" }}</td>
          </tr>
          <tr>
            <td style="background: #F7F7F7;">申请流程</td>
            <td>{{ dialogData[0].showData.path || "--" }}</td>
          </tr>
          <tr>
            <td style="background: #F7F7F7;">商品服务列表</td>
            <td>{{ dialogData[0].showData.goods || "--" }}</td>
          </tr>
          </tbody>

        </table>

      </div>

    </el-dialog>

    <el-dialog title="专利信息详情" :visible.sync="dialogData[1].show">
      <div style="height:70vh;overflow-y: scroll;" v-if="dialogData[1].showData">
        <table class="pure-table pure-table-bordered">
          <tbody>
          <tr>
            <td style="width:140px; background: #F7F7F7;">专利名称</td>
            <td>{{ dialogData[1].showData.name || "--" }}</td>
          </tr>
          <tr>
            <td style=" background: #F7F7F7;">申请日</td>
            <td>{{ dialogData[1].showData.date || "--" }}</td>
          </tr>
          <tr>
            <td style=" background: #F7F7F7;">申请号</td>
            <td>{{ dialogData[1].showData.number || "--" }}</td>
          </tr>
          <tr>
            <td style=" background: #F7F7F7;">公开日</td>
            <td>{{ dialogData[1].showData.date_end || "--" }}</td>
          </tr>
          <tr>
            <td style=" background: #F7F7F7;">公开号</td>
            <td>{{ dialogData[1].showData.public_number || "--" }}</td>
          </tr>
          <tr>
            <td style=" background: #F7F7F7;">法律状态</td>
            <td>{{ dialogData[1].showData.status || "--" }}</td>
          </tr>
          <tr>
            <td style=" background: #F7F7F7;">分类号</td>
            <td>{{ dialogData[1].showData.ipc || "--" }}</td>
          </tr>
          <tr>
            <td style=" background: #F7F7F7;">专利国际分类</td>
            <td>{{ dialogData[1].showData.cat || "--" }}</td>
          </tr>
          <tr>
            <td style=" background: #F7F7F7;">专利代理机构</td>
            <td>{{ dialogData[1].showData.agencyName || "--" }}</td>
          </tr>
          <tr>
            <td style=" background: #F7F7F7;">代理人</td>
            <td>{{ dialogData[1].showData.agentName || "--" }}</td>
          </tr>
          <tr>
            <td style=" background: #F7F7F7;">专利权人</td>
            <td>{{ dialogData[1].showData.applicantName || "--" }}</td>
          </tr>
          <tr>
            <td style=" background: #F7F7F7;">地址</td>
            <td>{{ dialogData[1].showData.address || "--" }}</td>
          </tr>
          <tr>
            <td style=" background: #F7F7F7;">发明人</td>
            <td>{{ dialogData[1].showData.inventorName || "--" }}</td>
          </tr>
          <tr>
            <td style=" background: #F7F7F7;">摘要</td>
            <td>{{ dialogData[1].showData.abs || "--" }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: [String, Number],
      default: ""
    },
    detail: {
      type: Object,
      default: ""
    }
  },
  data() {
    return {
      newlist: [],
      com: [{
        totalnum: 0,
        currentPage: 1,
        pagesize: 10,
        type: 6,

      }, {
        totalnum: 0,
        currentPage: 1,
        pagesize: 10,
        type: 7
      }, {
        totalnum: 0,
        currentPage: 1,
        pagesize: 10,
        type: 8
      }, {
        totalnum: 0,
        currentPage: 1,
        pagesize: 10,
        type: 9
      }, {
        totalnum: 0,
        currentPage: 1,
        pagesize: 10,
        type: 10
      }],
      dialogData: {
        0: {
          show: false,
          showData: {}
        },
        1: {
          show: false,
          showData: {}
        }
      },
      vctbIndex: 0,
      supporttotal_money: '',
      brand_list: [],
      patent_list: [],
      softright_list: [],
      copyright_list: [],
      pageSizes: [10, 20, 30, 40, 50]
    }
  },
  methods: {
    showDialog(index, data) {
      this.dialogData[index].show = true
      this.dialogData[index].showData = data
    },
    clickvctb(e) {
      this.vctbIndex = e
    },
    getbrand() {
      var api = this.$api.api.companydata.brand_list;
      this.$https.post({
            api: api,
            type: "formData",
          }, {
            start: this.com[0].currentPage,
            page_size: this.com[0].pagesize,
            id: this.id
          },
          (response) => {
            // console.log("response", response);
            if (response.data.length) {
              for (let i in response.data) {
                if (response.data[i].href) {
                  if (response.data[i].href.indexOf("http") == -1) {
                    response.data[i].href = 'http://' + response.data[i].href;
                  }
                }
              }
            }

            this.brand_list = response.data;
            this.com[0].totalnum = response.count || 0;

          },
          (error) => {
            // console.log(error);
          }
      );
    },
    getpatent() {
      var api = this.$api.api.companydata.patent_list;
      this.$https.post({
            api: api,
            type: "formData",
          }, {
            start: this.com[1].currentPage,
            page_size: this.com[1].pagesize,
            id: this.id
          },
          (response) => {
            // console.log("response", response);
            if (response.data.length) {
              for (let i in response.data) {
                if (response.data[i].href) {
                  if (response.data[i].href.indexOf("http") == -1) {
                    response.data[i].href = 'http://' + response.data[i].href;
                  }
                }
              }
            }
            this.patent_list = response.data;
            this.com[1].totalnum = response.count || 0;

          },
          (error) => {
            // console.log(error);
          }
      );
    },
    getsoftright() {
      var api = this.$api.api.companydata.softright_list;
      this.$https.post({
            api: api,
            type: "formData",
          }, {
            start: this.com[2].currentPage,
            page_size: this.com[2].pagesize,
            id: this.id
          },
          (response) => {
            // console.log("response", response);

            this.softright_list = response.data;
            this.com[2].totalnum = response.count || 0;

          },
          (error) => {
            // console.log(error);
          }
      );
    },
    getcopyright() {
      var api = this.$api.api.companydata.copyright_list;
      this.$https.post({
            api: api,
            type: "formData",
          }, {
            start: this.com[3].currentPage,
            page_size: this.com[3].pagesize,
            id: this.id
          },
          (response) => {
            // console.log("response", response);
            if (response.data.length) {
              for (let i in response.data) {
                if (response.data[i].href) {
                  if (response.data[i].href.indexOf("http") == -1) {
                    response.data[i].href = 'http://' + response.data[i].href;
                  }
                }
              }
            }
            this.copyright_list = response.data;
            this.com[3].totalnum = response.count || 0;

          },
          (error) => {
            // console.log(error);
          }
      );
    },
    handleCurrentChange(currentPage, index) {
      this.com[index].currentPage = currentPage;
      // console.log(this.currentPage) //点击第几页
      // this.rightlist = [];
      switch (index) {
        case 0:
          this.getbrand();
          break;
        case 1:
          this.getpatent();
          break;
        case 2:
          this.getsoftright();
          break;
        case 3:
          this.getcopyright();
          break;
      }
    },
    getNumber() {
      let num = 0
      this.com.forEach(item => {
        num += item.totalnum
      })
      this.$emit("rNum", num)
    },
    handleSizeChange(size, index) {
      this.com[index].pagesize = size;
      this.com[index].currentPage = 1;
      // console.log(this.currentPage) //点击第几页
      // this.rightlist = [];
      switch (index) {
        case 0:
          this.getbrand();
          break;
        case 1:
          this.getpatent();
          break;
        case 2:
          this.getsoftright();
          break;
        case 3:
          this.getcopyright();
          break;
      }
    }, toout(href) {
      // console.log(href)
      if (!href) {
        return false;
      }
      window.open(href)
    },
  },
  created() {
    this.getbrand();
    this.getpatent();
    this.getsoftright();
    this.getcopyright();

  }
}
</script>

<style lang="scss" scoped>
@import '../detailcss.scss';
</style>



// WEBPACK FOOTER //
// intellectual-page.vue?85f2be4e